export default __webpack_public_path__ + "static/media/limit_5.9ce6b04d.svg";